import axios from 'axios';

const URL = import.meta.env.VITE_APP_API_URL;

const adminAxios = axios.create({
        baseURL: URL,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        error ? prom.reject(error) : prom.resolve(token);
    });
    failedQueue = [];
};

// ➤ Добавляем токен к каждому запросу
adminAxios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('adminAccessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ➤ Перехват 403 и обновление токена
adminAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        const status = error.response?.status;
        const message = error.response?.data?.message;

        // Если не 403 или уже была попытка, или явно "Доступ запрещён" — не пробуем рефреш
        if (status !== 403 || originalRequest._retry || message === 'Доступ запрещён') {
            return Promise.reject(error);
        }

        const accessToken = localStorage.getItem('adminAccessToken');
        const refreshToken = localStorage.getItem('adminRefreshToken');

        if (!accessToken || !refreshToken) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({ resolve, reject });
            })
                .then(token => {
                    originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    return adminAxios(originalRequest);
                })
                .catch(err => Promise.reject(err));
        }

        isRefreshing = true;

        try {
            const res = await axios.post(`${URL}/admin/auth/refresh`, {
                refreshToken,
            });

            const newAccess = res.data.accessToken;
            const newRefresh = res.data.refreshToken;

            localStorage.setItem('adminAccessToken', newAccess);
            localStorage.setItem('adminRefreshToken', newRefresh);

            adminAxios.defaults.headers.common['Authorization'] = `Bearer ${newAccess}`;
            processQueue(null, newAccess);

            originalRequest.headers['Authorization'] = `Bearer ${newAccess}`;
            return adminAxios(originalRequest);
        } catch (err) {
            processQueue(err, null);

            // Удаляем токены при любом провале refresh
            localStorage.removeItem('adminAccessToken');
            localStorage.removeItem('adminRefreshToken');

            // Без редиректа, просто возвращаем ошибку
            return Promise.reject(err);
        } finally {
            isRefreshing = false;
        }
    }
);

export default adminAxios;
